<div class="table-view__container" [tabIndex]="-1" (window:resize)="onResize()">
  <!-- Table Header -->
  <div class="table-view__header-wrapper">
    <table class="table-view__table">
      <thead>
        <tr>
          <th
            *ngFor="
              let columnName of tableViewData.columnsHeaders;
              let i = index
            "
            [attr.id]="'col-' + i"
            scope="col"
            #headerColumn
          >
            {{ columnName }}
          </th>
        </tr>
      </thead>
    </table>
  </div>

  <!-- Table Body -->
  <div class="patched-table-container">
    <div #tableBodyContainer class="table-view__body-container">
      <table #tableBody class="table-view__table">
        <tbody>
          <tr
            *ngFor="
              let row of tableViewData.displayedRows;
              let rowIndex = index
            "
          >
            <td
              *ngFor="let cellContent of row.cells; let cellIndex = index"
              [attr.headers]="'col-' + cellIndex"
            >
              {{ cellContent }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="bottom-left-corner-patch">
      <div class="bottom-left-corner-patch__inner"></div>
    </div>
  </div>
</div>
